<app-breadcrumb [title]="'Actividades de Capacitación'" [items]="['Capacitaciones']" [active_item]="'Actividades'">
</app-breadcrumb>

<div class="container-fluid">

  <!-- Tarjetas resumen -->
  <div class="row g-3 mb-3" *ngIf="!loading">
    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 stat-card stat-card--total">
        <div class="card-body d-flex align-items-center">
          <i class="icofont icofont-tasks stat-card__icon"></i>
          <div>
            <div class="stat-card__value">{{ totalActividades }}</div>
            <div class="stat-card__label">Actividades registradas</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 stat-card stat-card--activos">
        <div class="card-body d-flex align-items-center">
          <i class="icofont icofont-check-circled stat-card__icon"></i>
          <div>
            <div class="stat-card__value">{{ totalActivasCount }}</div>
            <div class="stat-card__label">Actividades activas</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 stat-card stat-card--vigente">
        <div class="card-body d-flex align-items-center">
          <i class="icofont icofont-calendar stat-card__icon"></i>
          <div>
            <div class="stat-card__value">
              {{ proximaActividadProgramada ? (proximaActividadProgramada.fecha_programacion | date:'dd/MM') : '—' }}
            </div>
            <div class="stat-card__label">
              {{ proximaActividadProgramada ? 'Próxima actividad programada' : 'Sin próxima actividad' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="card shadow-sm border-0">
  <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <i class="icofont icofont-tasks me-2"></i>
      <h5 class="mb-0">
        <strong>ACTIVIDADES DE CAPACITACIÓN{{ nombreCapacitacionRuta ? ' – ' + nombreCapacitacionRuta : '' }}</strong>
      </h5>
    </div>
  </div>

    <div class="card-body custom-datatable noscroll">
      <div class="row mb-3">
        <div class="col-sm-12 col-md-3">
          <ng-select [items]="[
              { value: 'all',      label: 'Todos'     },
              { value: 'active',   label: 'Activos'   },
              { value: 'inactive', label: 'Inactivos' }
            ]" bindLabel="label" bindValue="value" [(ngModel)]="stateFilter" (change)="page = 1; filterData()"
            [clearable]="false">
          </ng-select>
        </div>

        <div class="col-sm-12 col-md-3 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="searchText"
              (input)="filterData()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="custom-datatable table-responsive mt-4" *ngIf="!loading; else skeleton">
       <table class="table table-bordered table-hover align-middle" id="tblActividades">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>DIRIGIDO A</strong></th>
              <th class="text-center"><strong>RESPONSABLE</strong></th>
              <th class="text-center"><strong>ACTIVIDADES ESPECÍFICAS</strong></th>

              <th class="text-center sortable" (click)="sortData('fecha_programacion')">
                <strong>F. PROGRAMACIÓN</strong>
                <i class="fa" [ngClass]="{
                    'fa-sort-up':   sortColumn === 'fecha_programacion' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'fecha_programacion' && sortDirection === 'desc',
                    'fa-sort':      sortColumn !== 'fecha_programacion'
                  }"></i>
              </th>
              <th class="text-center sortable" (click)="sortData('hora_inicio')">
                <strong>H. REUNIÓN</strong>
                <i class="fa" [ngClass]="{
                    'fa-sort-up':   sortColumn === 'hora_inicio' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'hora_inicio' && sortDirection === 'desc',
                    'fa-sort':      sortColumn !== 'hora_inicio'
                  }"></i>
              </th>

              <th class="text-center sortable" (click)="sortData('estado')">
                <strong>ESTADO</strong>
                <i class="fa" [ngClass]="{
                    'fa-sort-up':   sortColumn === 'estado' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'estado' && sortDirection === 'desc',
                    'fa-sort':      sortColumn !== 'estado'
                  }"></i>
              </th>

              <th class="text-center"><strong>ACCIONES</strong></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of filteredTableItems
                | paginate: { itemsPerPage: pageSize, currentPage: page }">

              <td class="text-center">
                <span class="badge bg-primary-subtle text-primary-emphasis">{{ item.CargosData?.cargos ?? "-" }}</span>
              </td>
              <td class="text-center">{{ item.nombre_responsable ?? "-" }}</td>

              <td class="text-uppercase">
                <span class="badge bg-light text-dark border me-1 mb-1 d-inline-block"
                  *ngFor="let sub of obtenerSubActividadesActivas(item)">
                  {{ sub.actividad }}
                </span>
                <span *ngIf="obtenerSubActividadesActivas(item).length === 0" class="text-primary">-</span>
              </td>

              <td class="text-center">{{ item.fecha_programacion | date: "dd/MM/yyyy" }}</td>
              <td class="text-center">{{ item.hora_inicio }} - {{ item.hora_fin }}</td>

              <td class="text-center">
                <span class="badge rounded-pill" [ngClass]="esActivo(item) ? 'bg-success' : 'bg-secondary'">
                  {{ esActivo(item) ? "Activo" : "Inactivo" }}
                </span>
              </td>

              <td class="text-center">
                <div class="d-flex justify-content-center gap-1">
                  <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded" ngbTooltip="Seguimientos"
                    (click)="abrirModalSeguimientos(item, seguimientosModal)">
                    <i class="icofont icofont-clock-time" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded" *ngIf="esActivo(item)"
                    ngbTooltip="Editar" (click)="abrirModalEditar(item, actividadModal)">
                    <i class="icon-pencil-alt" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded" *ngIf="esActivo(item)"
                    ngbTooltip="Inactivar" (click)="inactivarActividad(item.id)">
                    <i class="icon-trash" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded" *ngIf="!esActivo(item)"
                    ngbTooltip="Activar" (click)="activarActividad(item.id)">
                    <i class="icon-check-box" style="font-size: .85rem;"></i>
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="!loading && filteredTableItems.length === 0">
              <td colspan="7" class="text-center text-primary py-4">
                <i class="icofont icofont-search-document" style="font-size: 1.4rem;"></i>
                <p class="mb-0 mt-2">No hay actividades registradas.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex align-items-center">
          <label for="pageSize" class="me-2">Mostrar:</label>
          <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="text-center flex-grow-1">
          Total Registros:
          <a class="badge badge-primary"><b>{{ filteredTableItems?.length }}</b></a>
        </div>

        <div class="text-end paginador-personalizado">
          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>

      <div class="mt-4">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" type="button"
            (click)="exportarExcel('tblActividades', 'Listado_actividades')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>

          <button class="btn btn-outline-danger-2x" type="button"
            (click)="exportToPDF('tblActividades', 'Listado_actividades', 'Listado de Actividades de Capacitación')">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>

          <button class="btn btn-outline-primary-2x" type="button" (click)="abrirModalNuevo(actividadModal)">
            <i class="fa fa-plus"></i> CREAR
          </button>
        </div>
      </div>

      <ng-template #skeleton>
        <div class="skeleton-table my-3">
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th *ngFor="let col of [1,2,3,4,5,6,7]">
                  <div class="skeleton skeleton-th"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of [].constructor(5)">
                <td *ngFor="let col of [1,2,3,4,5,6,7]">
                  <div class="skeleton skeleton-td"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>

    </div>
  </div>
</div>

<!-- ===================== MODAL: CREAR / EDITAR ACTIVIDAD ===================== -->
<ng-template #actividadModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title mb-0">
      <strong>{{ modoEdicion ? "EDITAR ACTIVIDAD" : "NUEVA ACTIVIDAD" }}</strong>
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">

    <div class="form-section">
      <div class="form-section__title"><i class="fa fa-info-circle me-1"></i>Información general</div>
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label text-dark"><strong>Capacitación:</strong></label>
          <input type="text" class="form-control text-uppercase" [value]="nombreCapacitacionRuta" disabled readonly />
        </div>

        <div class="col-md-6">
          <label class="form-label text-dark">
            <strong>Dirigido a:</strong><a class="text-danger"> *</a>
          </label>
          <ng-select [items]="responsables" bindLabel="cargos" bindValue="id" [(ngModel)]="actividadForm.dirigido"
            name="dirigido" placeholder="Seleccione..." [clearable]="false">
          </ng-select>
        </div>

        <div class="col-md-6">
          <label class="form-label text-dark">
            <strong>Responsable:</strong><a class="text-danger"> *</a>
          </label>
          <ng-select [items]="propietarios" bindLabel="nombreCompleto" bindValue="cedula" [(ngModel)]="actividadForm.responsable"
            name="responsable" placeholder="Seleccione..." [clearable]="false">
          </ng-select>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="form-section__title"><i class="fa fa-calendar me-1"></i>Programación</div>
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label text-dark">
            <strong>Fecha programación:</strong><a class="text-danger"> *</a>
          </label>
          <input type="date" class="form-control" [min]="rangoProgramacion.fecha_inicio"
            [max]="rangoProgramacion.fecha_final" [(ngModel)]="actividadForm.fecha_programacion"
            name="fecha_programacion" />
        </div>

        <div class="col-md-4">
          <label class="form-label text-dark"><strong>Hora inicio:</strong></label>
          <input type="time" class="form-control" [(ngModel)]="actividadForm.hora_inicio" name="hora_inicio" />
        </div>

        <div class="col-md-4">
          <label class="form-label text-dark"><strong>Hora fin:</strong></label>
          <input type="time" class="form-control" [(ngModel)]="actividadForm.hora_fin" name="hora_fin" />
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="form-section__title d-flex justify-content-between align-items-center">
        <span><i class="fa fa-list-ul me-1"></i>Actividades específicas <a class="text-danger">*</a></span>
        <button class="btn btn-outline-primary btn-sm" type="button" (click)="agregarSubActividad()">
          <i class="fa fa-plus"></i> Agregar
        </button>
      </div>

      <div class="row g-2 align-items-center mb-2" *ngFor="let sub of subActividades; let i = index; trackBy: trackByIndex">
        <div class="col-10">
          <input type="text" class="form-control text-uppercase"
            placeholder="Describa la actividad. Ej. Inducción SST" [(ngModel)]="sub.actividad"
            [name]="'subActividad' + i" />
        </div>
        <div class="col-2 text-center">
          <button class="btn btn-sm btn-danger" type="button" [disabled]="subActividades.length === 1"
            (click)="eliminarSubActividad(i)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarActividad()">
      <span *ngIf="!loading">{{ modoEdicion ? "Actualizar" : "Guardar" }}</span>
      <span *ngIf="loading">Guardando...</span>
    </button>
  </div>
</ng-template>

<!-- ===================== MODAL: SEGUIMIENTOS (listado tabular) ===================== -->
<ng-template #seguimientosModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title mb-0"><i class="icofont icofont-clock-time me-2"></i><strong>SEGUIMIENTOS DE EJECUCIÓN</strong></h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

<div class="modal-body">
  <p class="text-black" *ngIf="nombreActividadSeguimientos">
    <strong>Actividad:</strong> {{ nombreActividadSeguimientos }}
  </p>

  <div class="alert alert-secondary d-flex align-items-center mb-3" *ngIf="!actividadSeguimientosActiva">
    <i class="icofont icofont-lock fs-5 me-2"></i>
    Esta actividad está <strong class="mx-1">inactiva</strong>, por lo tanto no se pueden crear ni modificar seguimientos.
  </div>

  <div class="text-end mb-2" *ngIf="actividadSeguimientosActiva">
    <button type="button" class="btn btn-primary btn-sm" (click)="abrirModalSeguimientoForm(seguimientoFormModal)">
      <i class="icofont icofont-plus me-1"></i>Agregar seguimiento
    </button>
  </div>
  ...

    <div *ngIf="!cargandoSeguimientos; else cargandoSeguimientosTpl" class="table-responsive">
      <ng-container *ngIf="listaSeguimientos?.length > 0; else sinSeguimientos">
        <table class="table table-bordered table-hover align-middle">
          <thead class="bg-primary text-white">
            <tr>
              <th class="text-center">OBSERVACIÓN</th>
              <th class="text-center">FECHA</th>
              <th class="text-center">ESTADO</th>
              <th class="text-center">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let seguimiento of listaSeguimientos; trackBy: trackBySeguimientoId">
              <td>{{ seguimiento.observaciones }}</td>
              <td class="text-center">{{ seguimiento.fechaCreacion | date:'dd/MM/yyyy HH:mm' }}</td>
              <td class="text-center">
                <span class="badge rounded-pill"
                  [ngClass]="seguimiento.estado === 1 ? 'bg-success' : 'bg-secondary'">
                  {{ seguimiento.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                </span>
              </td>
              <td class="text-center">
                <div class="d-flex justify-content-center gap-2">
                  <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded" ngbTooltip="Documentos"
                    (click)="abrirModalDocumentosSeguimiento(modalDocumentosSeguimiento, seguimiento)">
                    <i class="icofont icofont-file-document" style="font-size: .85rem;"></i>
                  </button>
                <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
  *ngIf="seguimiento.estado === 1 && actividadSeguimientosActiva" ngbTooltip="Editar"
  (click)="abrirModalSeguimientoForm(seguimientoFormModal, seguimiento)">
  <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
</button>
<button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
  *ngIf="seguimiento.estado === 1 && actividadSeguimientosActiva" ngbTooltip="Inactivar"
  (click)="cambiarEstadoSeguimiento(seguimiento)">
  <i class="icofont icofont-close" style="font-size: .85rem;"></i>
</button>
<button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
  *ngIf="seguimiento.estado !== 1 && actividadSeguimientosActiva" ngbTooltip="Activar"
  (click)="cambiarEstadoSeguimiento(seguimiento)">
  <i class="icofont icofont-check" style="font-size: .85rem;"></i>
</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>

      <ng-template #sinSeguimientos>
        <div class="text-center py-4 text-primary fst-italic">No hay seguimientos registrados.</div>
      </ng-template>
    </div>

    <ng-template #cargandoSeguimientosTpl>
      <div class="text-center py-4">
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>Cargando seguimientos...
      </div>
    </ng-template>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>

<!-- ===================== MODAL: FORMULARIO SEGUIMIENTO (crear/editar) ===================== -->
<ng-template #seguimientoFormModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      <i class="icofont icofont-edit me-2"></i>
      {{ seguimientoEditando ? 'Editar seguimiento' : 'Agregar seguimiento' }}
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="seguimientoForm" novalidate>
      <div class="mb-2">
        <label class="form-label text-black">Observación: <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="4" maxlength="3000" formControlName="observaciones"
          [class.is-invalid]="seguimientoForm.get('observaciones')?.invalid && seguimientoForm.get('observaciones')?.touched">
        </textarea>
        <div class="invalid-feedback"
          *ngIf="seguimientoForm.get('observaciones')?.invalid && seguimientoForm.get('observaciones')?.touched">
          Este campo es obligatorio (máx. 3000 caracteres).
        </div>
        <small class="text-secondary">Máximo 3000 caracteres.</small>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
      [disabled]="guardandoSeguimiento">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="guardarSeguimiento(modal)"
      [disabled]="guardandoSeguimiento">
      <span *ngIf="!guardandoSeguimiento">
        <i class="icofont icofont-save me-1"></i>{{ seguimientoEditando ? 'Guardar cambios' : 'Guardar seguimiento' }}
      </span>
      <span *ngIf="guardandoSeguimiento">
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
      </span>
    </button>
  </div>
</ng-template>

<!-- ===================== MODAL: DOCUMENTOS DEL SEGUIMIENTO ===================== -->
<ng-template #modalDocumentosSeguimiento let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      <button *ngIf="mostrandoPreviewDocumento" type="button" class="btn btn-sm btn-light me-2"
        (click)="cerrarPreviewDocumento()" ngbTooltip="Volver">
        <i class="icofont icofont-arrow-left"></i>
      </button>
      {{ mostrandoPreviewDocumento ? (documentoSeleccionado?.name || 'Documento') : 'Documentos del seguimiento' }}
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">

    <ng-container *ngIf="!mostrandoPreviewDocumento">

<div class="alert alert-secondary d-flex align-items-center mb-4"
  *ngIf="seguimientoSeleccionadoDocs?.estado === 0 || !actividadSeguimientosActiva">
  <i class="icofont icofont-lock fs-5 me-2"></i>
  {{ !actividadSeguimientosActiva
      ? 'Esta actividad está inactiva, por lo tanto no se pueden cargar ni modificar documentos.'
      : 'Este seguimiento está inactivo, por lo tanto no se pueden cargar ni modificar documentos.' }}
</div>


      <div class="mb-4" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0 && actividadSeguimientosActiva">
        <input type="file" class="d-none" id="inputDocumentosSeguimientoActividad" multiple (change)="onFileChangeDocumento($event)">
        <label for="inputDocumentosSeguimientoActividad"
          class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer">
          <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
          <p class="mb-2 fw-semibold text-primary text-center">Haz click o arrastra archivos para cargar</p>
          <span class="btn btn-primary btn-sm rounded-pill px-3">Seleccionar archivos</span>
        </label>
      </div>

      <div *ngIf="nuevosArchivosDocs.length > 0 && seguimientoSeleccionadoDocs?.estado !== 0 && actividadSeguimientosActiva" class="mb-4">
        <h6 class="fw-bold">Archivos seleccionados</h6>
        <div class="row g-2">
          <div class="col-6 col-md-3" *ngFor="let item of nuevosArchivosDocs; let i = index; trackBy: trackByIndex">
            <div class="card p-2 text-center h-100">
              <img *ngIf="item.preview" [src]="item.preview" class="mb-1 rounded" style="max-height: 90px; object-fit: cover;">
              <i *ngIf="!item.preview" class="fa fa-file-pdf-o fs-2 text-danger mb-1"></i>
              <small class="text-truncate d-block" [title]="item.file.name">{{ item.file.name }}</small>
              <button class="btn btn-sm btn-outline-danger mt-1" (click)="quitarArchivoNuevo(i)">
                <i class="bi bi-trash"></i> Quitar
              </button>
            </div>
          </div>
        </div>
        <button class="btn btn-success mt-3" [disabled]="subiendoDocumentos" (click)="subirDocumentosSeguimiento()">
          <span *ngIf="subiendoDocumentos" class="spinner-border spinner-border-sm me-1"></span>
          <i class="icofont icofont-cloud-upload me-1"></i> Subir {{ nuevosArchivosDocs.length }} archivo(s)
        </button>
      </div>

      <hr>

      <h6 class="fw-bold">Documentos cargados</h6>
      <div *ngIf="cargandoDocumentos" class="text-center py-3">
        <div class="spinner-border text-primary"></div>
      </div>

      <div *ngIf="!cargandoDocumentos && documentosSeguimiento.length === 0" class="text-primary text-center py-3">
        No hay documentos cargados para este seguimiento.
      </div>

      <div class="row g-2" *ngIf="!cargandoDocumentos && documentosSeguimiento.length > 0">
        <div class="col-12 col-md-4" *ngFor="let doc of documentosSeguimiento">
          <div class="card p-2 text-center h-100">
            <img *ngIf="doc.isImage" [src]="doc.url" class="mb-1 rounded cursor-pointer"
              style="max-height: 90px; object-fit: cover;" (click)="verDocumento(doc)">
            <i *ngIf="!doc.isImage" class="fa fa-file-pdf-o fs-2 text-danger mb-1 cursor-pointer"
              (click)="verDocumento(doc)"></i>
            <small class="text-truncate d-block" [title]="doc.name">{{ doc.name }}</small>
            <div class="d-flex gap-1 justify-content-center mt-1">
              <button class="btn btn-sm btn-outline-primary" (click)="verDocumento(doc)">
                <i class="icofont icofont-eye"></i>
              </button>
              <button class="btn btn-sm btn-outline-warning" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0 && actividadSeguimientosActiva"
  (click)="reemplazarDocumentoSeguimiento(doc)">
  <i class="icofont icofont-refresh"></i>
</button>
<button class="btn btn-sm btn-outline-danger" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0 && actividadSeguimientosActiva"
  (click)="eliminarDocumentoSeguimiento(doc)">
  <i class="icon-trash"></i>
</button>
            </div>
          </div>
        </div>
      </div>

    </ng-container>

    <ng-container *ngIf="mostrandoPreviewDocumento">
      <div class="text-center" style="min-height: 50vh;">

        <img *ngIf="documentoSeleccionado?.isImage" [src]="documentoSeleccionado?.url" class="img-fluid rounded"
          style="max-height: 65vh;">

        <iframe *ngIf="documentoSeleccionado?.isPdf" [src]="documentoSeleccionado?.urlSegura"
          style="width: 100%; height: 65vh; border: none;">
        </iframe>

        <div *ngIf="!documentoSeleccionado?.isImage && !documentoSeleccionado?.isPdf"
          class="d-flex flex-column align-items-center justify-content-center py-5">
          <i class="fa fa-file-o fs-1 text-secondary mb-3"></i>
          <p class="text-muted">Este tipo de archivo no se puede previsualizar en el navegador.</p>
        </div>

        <a *ngIf="documentoSeleccionado?.url" [href]="documentoSeleccionado?.url" target="_blank"
          class="btn btn-outline-primary mt-3">
          <i class="icofont icofont-download"></i> Abrir en pestaña nueva
        </a>
      </div>
    </ng-container>

  </div>

  <div class="modal-footer">
    <button *ngIf="mostrandoPreviewDocumento" type="button" class="btn btn-outline-secondary"
      (click)="cerrarPreviewDocumento()">
      <i class="icofont icofont-arrow-left me-1"></i>Volver al listado
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>